module.exports = __webpack_public_path__ + "front/img/17_m.54c0afac.png";